import { Controller } from "@hotwired/stimulus"

// Modal del envío que subió al pagar (<dialog>): se abre al cargar y se quita del DOM al cerrarse o antes
// del caché de Turbo, así no reaparece al volver. Doc: _docs/features/cart/cart_show.md → Decisiones
export default class extends Controller {
  connect() {
    this.beforeCache = () => this.element.remove()
    document.addEventListener("turbo:before-cache", this.beforeCache)
    if (!this.element.open) this.element.showModal()
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.beforeCache)
  }

  close() {
    if (this.element.open) this.element.close()
  }

  // El clic fuera del panel llega al propio <dialog> (su ::backdrop)
  backdrop(event) {
    if (event.target === this.element) this.close()
  }

  // close del <dialog> (botón, Esc, fondo): el aviso ya se vio
  closed() {
    this.element.remove()
  }
}
